<script>
  // import WinWidget from "../widget/win/WinWidget.svelte";
  // import MenuWidget from "../widget/menu/MenuWidget.svelte";

  import { popupMachine } from "Core/PopupStateMachine.js";

  import { useMachine } from "@xstate/svelte";
  import { campaingStore } from "Store/data.js";
  import { optionsStore } from "Store/data.js";


  import { fade } from "svelte/transition";

  import { appController } from "Core/AppController.js";
  import { Boundary } from "@crownframework/svelte-error-boundary";

  import { onMount } from "svelte";

  $: options = optionsStore.options;

  $: campaign =  campaingStore.campaign ;

  export function showMenu() {
    if ($options.isLobbyEnabled) {
        window.postMessage({ name: "open_lobby", eventType: $options.isGameListEnabled ? "games" : "drop" }, "*");             
     } else {
     	window.addEventListener("keydown", keyPress);
    	send({ type: "openMenu" });
    }
  }

  export function pause() {
    send({ type: "onPause" });
    //console.log("On pause| state:" + $state.value);
  }

  export function resume() {
    console.log("On resume| state:" + $state.value);
    send({ type: "onResume" });
  }

  function keyPress(ev) {
    if (ev.key == "Escape") close(); //ESC
  }

  let unsubcsribe = () => {};
  let unsubscribeFormWinAlert = () => {
    console.log("PopupManager unsubscribe, WinAlert ");
    unsubcsribe();
    //window.removeEventListener("message", onGamePause, { once: false });
    window.removeEventListener("message", onGamePause);
  };

  $: win = campaingStore.win;
  const clearWin = () => {
    campaingStore.clearWin();
  };

  let subscribeOnWinAlert = () => {
    unsubcsribe = campaingStore.subscribeAlert((winAlert) => {
      if (winAlert) {
        //window.addEventListener("message", onGamePause, { once: false });
        window.addEventListener("message", onGamePause);
        window.postMessage(
          { name: "pause_safe_gameplay", callback: "game_paused" },
          "*"
        );
      }
    });
  };

  const { state, send } = useMachine(
    popupMachine.withContext({ campaingStore }),
    {
      actions: {
        pauseGame: () => window.postMessage({ name: "pause_gameplay" }, "*"),
        subscribeWin: (context) => {
          window.postMessage({ name: "resume_gameplay" }, "*");
          subscribeOnWinAlert();
        },
        unsubscribeWin: (context) => unsubscribeFormWinAlert(),
        clearWin: () => {
          clearWin();
        },
        updateAllData: () => {
          appController.updateAllData();
        },
      },

      guards: {
        //hasWins: (context) => context.campaingState.hasNewWins() === true,
        hasWins: (context) => campaingStore.hasNewWins(),
        hasNoWins: (context) => !campaingStore.hasNewWins(),
        //hasWins: (context) => true,
      },
    }
  );

  function onGamePause(eventData) {
    if (eventData.data === "game_paused") {
      //window.removeEventListener("message", onGamePause, false);
      console.log("PopupManager OnGamePaused state:" + $state.value);
      send({ type: "onGamePaused" });
    }
  }

  function close() {
    send("close");
    window.removeEventListener("keydown", keyPress);
  }

  //TODO: make spetial state on exit
  onMount(() => {
    return () => {
      close();
    };
  });

  function onError(err) {
    console.error("on open PopUp error:" + err);
    sentryHub.captureMessage(
      SentryErrorType.UI_ERrROR + ": on boundary: " + err
    );
  }
</script>

<!-- <div>
  {$state.value}
</div> -->
<Boundary {onError}>
  <!-- {#if $state.matches("OPEN_WIN")} -->
  {#if $state.value === "OPEN_WIN"}
    <div class="modal" on:click|preventDefault={close}>
      <div class="content" on:click|stopPropagation={() => {}}>
        
        <!-- <WinWidget on:closeWin={() => close()} /> -->

        <svg
          class="close"
          in:fade={{ delay: 300 }}
          on:click|stopPropagation={() => close()}
          viewBox="0 0 24 24"
        >
          <line x1="4" y1="4" x2="20" y2="20" />
          <line x1="20" y1="4" x2="4" y2="20" />
        </svg>
      </div>
    </div>
  {/if}

  <!-- {#if $state.matches("OPEN_MENU")} -->
  {#if $state.value === "OPEN_MENU"}
    <div class="modal" on:click|stopPropagation={close}>
      <div class="content" on:click|stopPropagation={() => {}}>
        <!-- <MenuWidget /> -->

        <svg
          class="close"
          in:fade={{ delay: 300 }}
          on:click|stopPropagation={close}
          on:mousedown|stopPropagation
          on:mouseup|stopPropagation
          viewBox="0 0 24 24"
        >
          <line x1="4" y1="4" x2="20" y2="20" />
          <line x1="20" y1="4" x2="4" y2="20" />
        </svg>
      </div>
    </div>
  {/if}
</Boundary>

<style>
  .modal {
    --visibility: hidden;
    z-index: 9999;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000000aa;
    display: flex;
    justify-content: center;
  }

  .content {
    position: relative;
    --background: yellow;
    width: min(1024px, 90%, 46vh);
    margin-top: 10vh;
    --margin: 10vh auto;
    font-size: min(90vw / 1024 * 16, 46vh / 1024 * 16, 16px);
  }
  @media (orientation: landscape) {
    .content {
      height: calc(90vh - 200px * var(--game-scale));
    }
  }
  @media (orientation: portrait) {
    .content {
      height: calc(90vh - 360px * var(--game-scale));
    }
  }
  /* .visible {
    visibility: visible !important;
  } */

  .close {
    position: absolute;
    top: 4em;
    right: 4em;
    width: 3em;
    height: 3em;
    cursor: pointer;
    transition: transform 0.15s ease-in-out;
    z-index: 4;
  }
  .close:hover {
    transform: scale(1.5);
  }
  .close line {
    stroke: #ffffff;
    stroke-width: 2;
    stroke-linecap: round;
  }
</style>
